import { Ref } from '@vue/composition-api';

export interface IFilter {
  id: string;
  selected: boolean;
}

// TODO add type for dataToFilter, IProduct in types does not match
interface IFilterSortParams {
  filterList: string[];
  dataToFilter: any;
  filters: IFilter[];
  activeSort: Ref<string>;
}

interface ISortMap {
  [key: string]: (itemList: any) => any;
}

export function useFilterSort({
  filterList, dataToFilter, filters, activeSort,
} : IFilterSortParams) {
  const sort = activeSort.value;
  const data = [...dataToFilter];

  const selectedFilters = filterList?.filter((filterId) => filters.find((filter) => filter.id === filterId)?.selected)
    .map((filterId) => filterId);

  const items = data.filter((accessory: any) => selectedFilters.some((filterType) => accessory?.types?.includes(filterType)));
  const filteredItems = items.length === 0 ? data : items;

  function bestSellersSort(itemList: any) {
    return itemList.sort((a: any, b: any) => {
      const indexA = data.indexOf(a);
      const indexB = data.indexOf(b);
      return indexA - indexB;
    });
  }

  function aToZSort(itemList: any) {
    return itemList.sort((a: any, b: any) => a.title.localeCompare(b.title));
  }

  function zToASort(itemList: any) {
    return itemList.sort((a: any, b: any) => b.title.localeCompare(a.title));
  }

  function lowSort(itemList: any) {
    return itemList.sort((a: any, b: any) => (a?.product?.price ?? a.price) - (b?.product?.price ?? b.price));
  }

  function highSort(itemList: any) {
    return itemList.sort((a: any, b: any) => (b?.product?.price ?? b.price) - (a?.product?.price ?? a.price));
  }

  const sortMap: ISortMap = {
    'Best Sellers': bestSellersSort,
    'From A-Z': aToZSort,
    'From Z-A': zToASort,
    'Price Low to High': lowSort,
    'Price High to Low': highSort,
  };

  const itemsToDisplay = sort?.length ? sortMap[sort](filteredItems) : filteredItems;

  return {
    itemsToDisplay,
  };
}
